import {Amplify} from "aws-amplify";
import {
    getCurrentUser as amplifyGetCurrentUser,
    signOut as amplifySignOut,
    fetchAuthSession,
    fetchUserAttributes,
} from "aws-amplify/auth";
import {dismissNotifications} from "reapop";
import Paths from "../api/paths";
import store from "../store/store";
import {myID} from "./generateID";
// import {redirect} from "../actions/historyActions";
import queryString from "querystring";
import {addSyncAPI} from "../actions/syncActions";
import APICallError from "../errors/APICallError";
import {isCypressOffline} from "../utils/CypressUtils";
import {
    bugsnagClient,
    discardBugsnagError,
} from "../utils/bugsnagUtils/BugsnagUtils";

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
            identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        },
    },
});

export async function authUser() {
    try {
        const session = await fetchAuthSession();
        console.log("authUser session", session);
        if (
            session.credentials?.expiration &&
            new Date() > session.credentials.expiration
        ) {
            await refreshSession();
        }
        const user = await amplifyGetCurrentUser();
        if (user) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return Promise.reject(e);
    }
}

export async function getUserToken() {
    try {
        const session = await fetchAuthSession();
        return session.tokens?.accessToken?.toString();
    } catch (e) {
        console.error(e);
        try {
            await amplifySignOut();
        } catch (e) {
            console.error(e);
        }
    }
}

export async function getUserIdToken() {
    try {
        const session = await fetchAuthSession();
        return session.tokens?.idToken?.toString();
    } catch (e) {
        console.error(e);
    }
}

export async function getCurrentUser(bypassCache = false) {
    try {
        if (bypassCache) {
            await fetchAuthSession({forceRefresh: true});
        }
        const user = await amplifyGetCurrentUser();
        const attributes = await fetchUserAttributes();
        return {username: user.username, attributes};
    } catch (e) {
        console.error(e);
        return null;
    }
}

export async function signOutUser() {
    try {
        await amplifySignOut();
    } catch (e) {
        console.error(e);
    }
    // store.dispatch(redirect("/"));
    store.dispatch(dismissNotifications());
}

// function getAwsCredentials(userToken) {
//     const authenticator = `cognito-idp.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${process.env.REACT_APP_COGNITO_USER_POOL_ID}`;
//
//     AWS.config.update({region: process.env.REACT_APP_AWS_REGION});
//
//     AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//         IdentityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
//         Logins: {
//             [authenticator]: userToken
//         }
//     });
//
//     return AWS.config.credentials.getpromise;
// }

function saveOfflineSync({path, method, headers, body, query}) {
    // nie zapisuj:
    // - zapytan typu GET
    // - zapytan z iot w sciezce
    // - gdy na widoku wprowadzania danych przez gridy
    if (
        method !== "GET" &&
        !path.includes("iot") &&
        !location.href.includes("eventChooser") &&
        !location.href.includes("settings/devices/scan") &&
        !path.startsWith("offline") &&
        !path.startsWith("userapi") &&
        !path.includes("/sns/")
    ) {
        store.dispatch(addSyncAPI(path, method, headers, query, body));
    }
}

function notifyBugsnag(
    e,
    {
        path,
        method,
        headers,
        queryParams,
        body,
        noAuthorization,
        signal,
        query,
        token,
        result = {},
    }
) {
    const state = store.getState();
    const {
        user: {
            user: {LocalUserID, ClientID},
        },
        location: {farm},
        online: {status},
    } = state;
    const replacedPath = path
        .replace(farm, "{FarmID}")
        .replace(LocalUserID, "{LocalUserID}")
        .replace(ClientID, "{ClientID}");
    if (status && !discardBugsnagError({...e, error: e.message})) {
        bugsnagClient.notify(
            new Error(replacedPath),
            (event) => {
                event.severity = "warn";
                event.addMetadata("feedback", {
                    messageType: e.message,
                    data: {
                        method,
                        headers,
                        queryParams,
                        body,
                        noAuthorization,
                        signal,
                        query,
                        token,
                        result,
                    },
                    error: e,
                });
            },
            () => {}
        );
    }
}

export async function invokeApig({
    path,
    method = "GET",
    headers = {},
    queryParams = {},
    body,
    noAuthorization,
    signal,
    shouldParse = true,
    forceFetch = false,
}) {
    // i18next.setDefaultNamespace("translation"); // todo bedzie common
    let token;
    if (!noAuthorization) {
        token = await getUserToken();
    }
    if (body && typeof body === "object") {
        headers["Content-Type"] = "application/json";
    }
    body = body ? (shouldParse ? JSON.stringify(body) : body) : body;
    headers.authorization = noAuthorization ? "" : token;
    if (forceFetch) {
        headers["Cache-Control"] = "max-age=0";
    }

    let query = queryString.stringify(queryParams);
    console.log(headers, typeof body);
    if (isCypressOffline()) {
        saveOfflineSync({method, body, headers, path, query});
        return;
    }
    try {
        const results = await fetch(
            process.env.REACT_APP_API_URL + path + (query ? "?" + query : ""),
            {
                // const results = await fetch(signedRequest.url, {
                method,
                headers,
                body,
                signal,
            }
        );
        if (!results.ok) {
            const r = await results.json();
            notifyBugsnag(
                {message: "API Call error", name: "Inoke a pig error"},
                {
                    path,
                    method,
                    headers,
                    queryParams,
                    body,
                    noAuthorization,
                    signal,
                    query,
                    token,
                    result: r,
                    status: results.status,
                    resultsBody: results.body,
                }
            );
            const tmp = Array.isArray(r)
                ? {data: r}
                : {...JSON.parse(JSON.stringify(r))};
            delete tmp.message;
            return Promise.reject(
                new APICallError(
                    Array.isArray(r)
                        ? r.length === 1
                            ? r[0].message
                            : "Multiple errors"
                        : r.message || "Unknown error",
                    tmp
                )
            );
        }
        if (results.headers.get("Content-Type") === "text/plain") {
            return results.text();
        }
        if (results.headers.get("Content-Type") !== "application/json") {
            let base64 = await results.text();
            let buff = Buffer.from(base64, "base64");
            let blob = new Blob([buff], {
                type: results.headers.get("Content-Type"),
            });
            let url = window.URL.createObjectURL(blob);
            console.log(results.headers.get("Content-Disposition"));
            let filename = results.headers
                .get("Content-Disposition")
                .split("filename=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            return;
        }
        // console.log('RESULT ivokeapig', results);
        return results.json();
    } catch (e) {
        console.error(e);
        if (e.name !== "AbortError") {
            saveOfflineSync({method, body, path, headers, query});
        }
        notifyBugsnag(e, {
            path,
            method,
            headers,
            queryParams,
            body,
            noAuthorization,
            signal,
            query,
            token,
        });
        return Promise.reject(e);
    }
}

export async function createAndUpdateGroup(
    newAnimal,
    oldAnimal,
    event,
    clientID,
    localUserID
) {
    try {
        //console.log(newAnimal);
        //dodanie nowego zwierzęcia
        await invokeApig({
            ...Paths.createAnimal({
                farmID: oldAnimal.FarmID,
                localUserID: localUserID,
                clientID: clientID,
            }),
            body: newAnimal,
        });
        //nadpisanie starego zwierzęcia
        await invokeApig({
            ...Paths.updateAnimal({
                farmID: oldAnimal.FarmID,
                localUserID: localUserID,
                clientID: clientID,
            }),
            body: oldAnimal,
        });
        //pobranie listy eventów starego zwierzęcia
        let eventsResponse = await invokeApig({
            ...Paths.listEvent({farmID: oldAnimal.FarmID}),
            queryParams: {FarmID: oldAnimal.FarmID, AnmID: oldAnimal.AnmID},
        });
        eventsResponse.map((e) => {
            e.EvID = myID();
            e.AnmID = newAnimal.AnmID;
        });
        let events = eventsResponse.concat(event);
        let e = {
            events: events,
        };
        //dodanie eventów dla nowego zwierzęcia
        await invokeApig({
            ...Paths.createEvent(),
            body: e,
        });
    } catch (e) {
        //console.log("catch promise fetch",e);
        return Promise.reject(new Error("Failed to create or update"));
    }
}

export async function createAndUpdateNotificattions(
    newAnimal,
    oldAnimal,
    event
) {
    try {
        //console.log(newAnimal);
        //dodanie nowego zwierzęcia
        // let newAnimalRes = await invokeApig({
        //     path: "api/animal",
        //     method: "POST",
        //     body: newAnimal
        // });
        //nadpisanie starego zwierzęcia
        // let oldAnimalRes = await invokeApig({
        //     path: "api/animal/" + oldAnimal.FarmID,
        //     method: "PUT",
        //     body: oldAnimal
        // });
        //pobranie listy eventów starego zwierzęcia
        let eventsResponse = await invokeApig({
            ...Paths.listEvent({farmID: oldAnimal.FarmID}),
            method: "GET",
            queryParams: {FarmID: oldAnimal.FarmID, AnmID: oldAnimal.AnmID},
        });
        eventsResponse.map((e) => {
            e.EvID = myID();
            e.AnmID = newAnimal.AnmID;
        });
        // let events = eventsResponse.concat(event);
        // let e = {
        //     events: events
        // };
        //dodanie eventów dla nowego zwierzęcia
        // let addEvents = await invokeApig({
        //     path: "api/events",
        //     method: "POST",
        //     body: e
        // })
    } catch (e) {
        //console.log("catch promise fetch",e);
        return Promise.reject(new Error("Failed to create or update"));
    }
}

export function refreshSession() {
    return new Promise(async (resolve, reject) => {
        try {
            const session = await fetchAuthSession({forceRefresh: true});
            resolve({
                idToken: {jwtToken: session.tokens?.idToken?.toString()},
                refreshToken: {token: undefined},
                accessToken: {
                    jwtToken: session.tokens?.accessToken?.toString(),
                },
            });
        } catch (e) {
            reject(e);
        }
    });
}

/*
export async function getContent(language = 'en') {
    return content.filter(obj => obj.lang === language)[0];
}*/
